import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';

function HomeServices() {
    
    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) el.style.backgroundImage = `url('/${bg}')`;
        });
    }, []);

    return (
        <>
            {/* <!-- Loan Services Section Begin --> */}
            <section className="loan-services spad">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>Discover All The Loans & Services For You</h2>
                                <p>We offer a comprehensive range of financial products tailored to meet your personal and business needs.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="loan__services__list">
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/pl-loan.png">
                            <div className="loan__services__item__text">
                                <h5><span>01.</span> Personal Loan</h5>
                                <p>Quick funds for your personal needs — medical, travel, education, and more.</p>
                                <Link to="/contact" state={{ service: "personal" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/bl-loan.png">
                            <div className="loan__services__item__text">
                                <h5><span>02.</span> Business Loan</h5>
                                <p>Fuel your business growth with flexible funding and easy repayment options.</p>
                                <Link to="/contact" state={{ service: "business" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/apl-loan.png">
                            <div className="loan__services__item__text">
                                <h5><span>03.</span> Loan Against Property</h5>
                                <p>Unlock the value of your property to meet large financial requirements.</p>
                                <Link to="/contact" state={{ service: "loan_against_property" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/card.png">
                            <div className="loan__services__item__text">
                                <h5><span>04.</span> Credit Card</h5>
                                <p>Enjoy rewards, cashback, and flexible credit with our top card offers.</p>
                                <Link to="/contact" state={{ service: "credit_card" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/btt.png">
                            <div className="loan__services__item__text">
                                <h5><span>05.</span> Balance Transfer / Top-Up</h5>
                                <p>Transfer your existing loan at lower interest rates and get additional top-up funds.</p>
                                <Link to="/contact" state={{ service: "balance_transfer" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/gold-loan.png">
                            <div className="loan__services__item__text">
                                <h5><span>06.</span> Gold Loan</h5>
                                <p>Get instant funds against your gold with minimal documentation and fast disbursal.</p>
                                <Link to="/contact" state={{ service: "gold" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/car-loan.png">
                            <div className="loan__services__item__text">
                                <h5><span>07.</span> Car Loan</h5>
                                <p>Drive your dream car home today with affordable EMIs and quick approval.</p>
                                <Link to="/contact" state={{ service: "car" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/home-loan.png">
                            <div className="loan__services__item__text">
                                <h5><span>08.</span> Home Loan</h5>
                                <p>Make your dream home a reality with our competitive home loan solutions.</p>
                                <Link to="/contact" state={{ service: "home" }}>Get Details</Link>
                            </div>
                        </div>
                        <div className="loan__services__item set-bg" data-setbg="img/loan-services/insurance.png">
                            <div className="loan__services__item__text">
                                <h5><span>09.</span> Insurance</h5>
                                <p>Protect your life, health, and assets with the right insurance coverage for you.</p>
                                <Link to="/contact" state={{ service: "insurance" }}>Get Details</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Loan Services Section End --> */}
        </>
    );
}

export default HomeServices;